import React, { useEffect, useState } from 'react';
import axios from '../../utils/axiosConfig';
import { Box, Typography, TextField, Button, Card, CardContent, CardActions, Grid, Dialog, DialogTitle, DialogContent, DialogActions, MenuItem, Tooltip, IconButton } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';

const TenantMembers = () => {
  const [tenants, setTenants] = useState([]);
  const [members, setMembers] = useState([]);
  const [tenantId, setTenantId] = useState('');
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ user_id: '', role: 'member' });

  const loadTenants = async () => {
    const res = await axios.get(`${process.env.REACT_APP_API_URL || 'https://backend.mtsdemo.de'}/api/tenants/`);
    setTenants(res.data);
  };

  const loadMembers = async (id) => {
    if (!id) { setMembers([]); return; }
    const res = await axios.get(`${process.env.REACT_APP_API_URL || 'https://backend.mtsdemo.de'}/api/tenant-members/${id}`);
    setMembers(res.data);
  };

  useEffect(() => { loadTenants(); }, []);
  useEffect(() => { loadMembers(tenantId); }, [tenantId]);

  const add = async () => {
    await axios.post(`${process.env.REACT_APP_API_URL || 'https://backend.mtsdemo.de'}/api/tenant-members/${tenantId}`, form);
    setOpen(false); setForm({ user_id: '', role: 'member' });
    await loadMembers(tenantId);
  };

  const remove = async (memberId) => {
    await axios.delete(`${process.env.REACT_APP_API_URL || 'https://backend.mtsdemo.de'}/api/tenant-members/${tenantId}/${memberId}`);
    await loadMembers(tenantId);
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <Typography variant="h4">Tenant-Mitglieder</Typography>
        <Tooltip
          title={
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600, mb: 1, color: '#FFD700' }}>
                Tenant-Mitglieder verwalten
              </Typography>
              <Typography variant="body2" sx={{ maxWidth: 300, lineHeight: 1.4 }}>
                Hier können Sie Benutzer zu verschiedenen Mandanten hinzufügen und deren Rollen verwalten. 
                Wählen Sie zuerst einen Mandanten aus, um dessen Mitglieder zu sehen und neue hinzuzufügen.
              </Typography>
            </Box>
          }
          placement="right"
          arrow
          componentsProps={{
            tooltip: {
              sx: {
                maxWidth: 350,
                backgroundColor: 'rgba(0, 0, 0, 0.9)',
                '& .MuiTooltip-arrow': {
                  color: 'rgba(0, 0, 0, 0.9)',
                },
              },
            },
          }}
        >
          <IconButton
            size="small"
            sx={{
              p: 0.5,
              color: '#FFD700',
              '&:hover': {
                backgroundColor: 'rgba(255, 215, 0, 0.1)',
                color: '#F57F17',
              },
            }}
          >
            <InfoIcon sx={{ fontSize: 20 }} />
          </IconButton>
        </Tooltip>
      </Box>
      <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'center' }}>
        <TextField 
          select 
          label="Mandant" 
          value={tenantId} 
          onChange={e => setTenantId(Number(e.target.value))}
          sx={{ 
            minWidth: 300,
            '& .MuiInputBase-root': {
              fontSize: '1rem',
            },
            '& .MuiSelect-select': {
              padding: '12px 14px',
            }
          }}
        >
          {tenants.map(t => <MenuItem key={t.id} value={t.id}>{t.name} ({t.slug})</MenuItem>)}
        </TextField>
        <Button 
          variant="contained" 
          onClick={() => setOpen(true)} 
          disabled={!tenantId}
          sx={{
            minHeight: '48px',
            px: 3,
            fontSize: '1rem',
            fontWeight: 600
          }}
        >
          Mitglied hinzufügen
        </Button>
      </Box>

      <Grid container spacing={2}>
        {members.map(m => (
          <Grid item xs={12} md={6} lg={4} key={m.id}>
            <Card>
              <CardContent>
                <Typography variant="h6">User-ID: {m.user_id}</Typography>
                <Typography variant="body2" color="text.secondary">Rolle: {m.role}</Typography>
              </CardContent>
              <CardActions>
                <Button size="small" color="error" onClick={() => remove(m.id)}>Entfernen</Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Mitglied hinzufügen</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
            <TextField label="User-ID" value={form.user_id} onChange={e => setForm({ ...form, user_id: Number(e.target.value) })} fullWidth />
            <TextField select label="Rolle" value={form.role} onChange={e => setForm({ ...form, role: e.target.value })} fullWidth>
              {['owner','admin','editor','viewer','member'].map(r => <MenuItem key={r} value={r}>{r}</MenuItem>)}
            </TextField>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Abbrechen</Button>
          <Button onClick={add} disabled={!tenantId} variant="contained">Speichern</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default TenantMembers;


